<template>
	<form class="register-form" autocomplete="off" @submit.prevent="submitForm">
		<div class="form-group">
			<label for="username">Username</label>
			<input
				type="text"
				class="form-control"
				name="username"
				placeholder="Username"
				v-model="user.username"
				:class="{ 'is-invalid': isInvalid.username }"
			/>
		</div>
		<div class="form-group">
			<label for="username">First Name</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				name="firstName"
				placeholder="First Name"
				v-model="user.firstName"
				:class="{ 'is-invalid': isInvalid.firstName }"
			/>
		</div>
		<div class="form-group">
			<label for="username">Last Name</label>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				name="lastName"
				placeholder="Last Name"
				v-model="user.lastName"
				:class="{ 'is-invalid': isInvalid.lastName }"
			/>
		</div>
		<div class="form-group">
			<label>E-mail</label>
			<input
				autocomplete="off"
				type="email"
				class="form-control"
				name="email"
				placeholder="E-mail Address"
				v-model="user.email"
				:class="{ 'is-invalid': isInvalid.email }"
			/>
		</div>
		<div class="form-group">
			<label>Password</label>
			<input
				autocomplete="off"
				type="password"
				class="form-control"
				name="password"
				placeholder="Password"
				v-model="user.password"
				:class="{ 'is-invalid': isInvalid.password }"
			/>
		</div>
		<div class="form-group">
			<label>Confirm password</label>
			<input
				autocomplete="off"
				type="password"
				class="form-control"
				name="confirm"
				placeholder="Confirm Password"
				v-model="user.confirm"
				:class="{ 'is-invalid': isInvalid.confirm }"
			/>
		</div>
		<div class="form-group">
			<div class="d-flex align-items-center">
				<input
					name="agree"
					type="checkbox"
					id="agree"
					v-model="acceptTerms"
					:class="{'is-invalid': isInvalid.terms }"
				/>
				<label class="ml-2" for="agree">
					I accept
				</label>
				<span
					class="text-primary hyper-click-primary ml-2 fw-bold"
					@click="readTerms"
				>
					terms and conditions
				</span>
			</div>
		</div>
		<div class="form-group mt-4">
			<button class="btn btn-primary w-100" type="submit">
				<span
					v-if="loading"
					class="spinner-border spinner-border-sm mr-2"
					role="status"
					aria-hidden="true"
				></span>
				Register
			</button>
		</div>
		<div class="form-group">
			Already registered? - 
			<span
				class="text-primary hyper-click-primary"
				@click="redirect('/console/login')"
			>
				Login
			</span>
		</div>
		<!--
		<div class="form-group">
			<span
				class="text-primary hyper-click-primary"
				@click="redirect('/')"
			>
				Return to home page
			</span>
		</div>
		-->
		<ErrorDialog ref="errDialog" />
		<TermsDialog ref="termsDialog" />
	</form>
</template>

<script>
import Register from "../../services/register";
import ErrorDialog from "../shared/ErrorDialog";
import TermsDialog from "../shared/TermsDialog";
import { API_PATH } from "../../../config/config";

export default {
	name: "RegisterForm",
	components: {
		ErrorDialog,
		TermsDialog
	},
	data: function () {
		return {
			user: {
				username: "",
				firstName: "",
				lastName: "",
				email: "",
				password: "",
				confirm: "",
			},
			isInvalid: {
				username: false,
				firstName: false,
				lastName: false,
				email: false,
				password: false,
				confirm: false,
				terms: false
			},
			loading: false,
			loginLink: API_PATH + "/console",
			acceptTerms: false
		};
	},
	methods: {
		submitForm() {
			let controls = Object.keys(this.user);
			let formInvalid = false;
			controls.forEach((c) => {
				if (!this.user[c]) {
					this.isInvalid[c] = true;
				} else {
					this.isInvalid[c] = false;
				}
			});
			if (this.user.password != this.user.confirm) {
				this.isInvalid.password = true;
				this.isInvalid.confirm = true;
			}
			this.isInvalid.terms = !this.acceptTerms;
			controls.forEach((c) => {
				if (this.isInvalid[c]) {
					formInvalid = true;
				}
			});
			if (formInvalid) return;

			let userToSend = {
				...this.user,
			};
			delete userToSend.confirm;

			this.registerUser(userToSend);
		},
		registerUser(user) {
			this.loading = true;
			Register.instance()
				.registerAccount(user)
				.then(() => {
					this.loading = false;
					this.$router.push({
						path: "/console/register/success?email="+this.user.email,
					});
				})
				.catch((err) => {
					this.loading = false;
					this.$refs.errDialog.show(err);
				});
		},
		redirect(path) {
			this.$router.push({ path });
		},
		readTerms() {
			this.$refs.termsDialog.show();
		},
	},
};
</script>